{
  "NTServiceForms": {
    "fields": {
      "travelingWithAssistant": {
        "note": "Tarvitset mukaasi oman avustajan, jos tarvitset apua lääkkeiden ottamisessa, syömisessä, wc:ssä käymisessä, itsesi nostamisessa, happinaamarin laittamisessa kasvoille, tai et pysty viestimään turvallisuusasioista matkustamohenkilökunnan kanssa."
      }
    },
    "specialAssistanceForm": {
      "additionalInformation": {
        "note": "Huomaathan, että emme vastaa tämän lomakkeen kautta muihin kuin avustuspalveluun ja/tai terveydentilaan liittyviin yhteydenottoihin."
      },
      "consentToProcessingMedicalData": "Täyttämällä ja lähettämällä tämän lomakkeen annat meille suostumuksen käsitellä terveystietojasi palvelupyyntösi käsittelemiseksi ja toteuttamiseksi. Suostumus pätee tarvittaessa myös yhteistyökumppaneihimme.",
      "fileUploader": {
        "note": "Lisääthän tarvittavat liitetiedostot (ylle merkityn avustustarpeen syyn mukaan) ennen kuin lähetät pyyntösi."
      }
    }
  }
}
